import { cn } from "../../lib/utils";

// Hyperliquid official PNG icon with CSS mask
// Uses currentColor to match sidebar text color
export function HyperliquidIcon({ className, ...props }) {
  return (
    <span
      aria-hidden="true"
      className={cn("inline-block bg-current", className)}
      style={{
        WebkitMaskImage: "url(/exchanges/hyperliquid.png)",
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskImage: "url(/exchanges/hyperliquid.png)",
        maskSize: "contain",
        maskRepeat: "no-repeat",
        maskPosition: "center",
      }}
      {...props}
    />
  );
}
